import { Injectable } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { Session } from '@models/Sessions/Session';
import { Workflow } from '@models/Sessions/Workflow';

import { RequestService } from '../request.service';

@Injectable()
export class SessionWorkflowService {
  api = {
    root: '/session/workflow/',
    move: 'copy/',
  };

  constructor(private client: RequestService) {}

  public load() {
    return this.client.get<Workflow>({
      uri: this.api.root,
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }

  public save(data) {
    return this.client.post({
      uri: this.api.root,
      body: data,
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }

  public moveIdeas(source: Session, ideas: Idea[], target: Session) {
    return this.client.post({
      uri: this.api.root + this.api.move,
      body: {
        source,
        ideas,
        target,
      },
      handlers: {
        success: () => void 0,
        error: () => void 0,
      },
    });
  }
}
